/* oxlint-disable react-hooks/rules-of-hooks -- tracked in docs/oxlint-violations.md */
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';

import { Loader } from '../../components/common/Loader';
import { SimplifiedPreviewDetails } from '../../components/preview-details/SimplifiedPreviewDetails';
import { getFragment } from '../../graphql';
import {
    GetAnonymousPrescriberOrderDocument,
    GetIndividualProviderDocument,
} from '../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../util';

export const SimplifiedPreviewDetailsRoute = () => {
    const navigate = useNavigate();
    const { providerId, drxId } = useParams();

    if (!providerId || !drxId) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    const {
        data: anonymousPrescriberOrderData,
        loading: anonymousPrescriberOrderLoading,
    } = useQuery(GetAnonymousPrescriberOrderDocument, {
        variables: { drxId },
        skip: !drxId,
    });

    const { data: individualProviderData, loading: individualProviderLoading } =
        useQuery(GetIndividualProviderDocument, {
            variables: { individualProviderId: providerId },
            skip: !providerId,
        });

    const provider = getFragment(
        anonymousPrescriberOrderData?.anonymousPrescriberOrder
            ?.assignedPharmacyProvider
    );

    // Redirect to order confirmation if already routed
    useEffect(() => {
        if (provider) {
            navigate(
                getAbsoluteRoute('direct.drxId.confirmation', {
                    drxId,
                })
            );
        }
    }, [provider, navigate, drxId]);

    if (anonymousPrescriberOrderLoading || individualProviderLoading) {
        return <Loader />;
    }

    const location = getFragment(individualProviderData?.individualProvider);

    if (!location) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return <SimplifiedPreviewDetails location={location} drxId={drxId} />;
};
